import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Logo from "../../video/Mariniz Logo Gold.png";
import axios from "axios";

import { toast } from "react-toastify";
import config from "../../../function/config";
import admin from "../AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";


export default function NewAdminNav() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isFlipped, setIsFlipped] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [isScrolled, setIsScrolled] = useState(false);

  // Track scrolling
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Automatically flip twice on page load
  const handleFlip = () => {
    setIsFlipped(false); // Temporarily set to false
    setTimeout(() => setIsFlipped((prevState) => !prevState), 10); // Reapply the flipped state
  };

 

 

  // signin
  const [username, setusername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [usernameError, setUsernameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [Signin, setSignin] = useState("Signin");
    // Validate username
    const validateUsername = (value) => {
      if (!value) {
        setUsernameError("Username is required");
      } else {
        setUsernameError("");
      }
    };
  
    // Validate password
    const validatePassword = (value) => {
      if (!value) {
        setPasswordError("Password is required");
      } else if (value.length < 4) {
        setPasswordError("Password must be at least 4 characters");
      } else {
        setPasswordError("");
      }
    };
  
    const handleSubmit = async () => {
      setLoading(true);
      const data = {
        email: username,
        password: password,
      };
      try {
        const response = await axios.post(
          `${config.base_url}/api/HappyMarineShipping/login`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.status === 200) {
          setLoading(false);
          console.log(response);
          localStorage.setItem("token", response.data.token);
          if (response.data.is_admin === true) {
            localStorage.setItem("admin", "t");
            console.log("Admin token:", response.data.token); // ✅ log admin token
            window.location.href = "/adminHome";
          } else {
            window.location.href = '/userHome'
          }
        } else {
          console.log(response);
          toast.error(response.data.message, {
            autoClose: 3000,
            position: "top-right",
          });
          setLoading(false);
        }
      } catch (err) {
        console.log("error2", err);
        toast.error("Error", {
          autoClose: 3000,
          position: "top-right",
        });
        setLoading(false);
      }
    };
  
    const [showPassword, setShowPassword] = useState(false);
     const [isLoginOpen, setIsLoginOpen] = useState(false);

   const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [image,setImage] = useState('')


  // Error states
  const [emailError, setEmailError] = useState(false);
  const [mobileError, setMobileError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);


    
  
  // Email validation (simple regex)
  const validateEmail = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError(!emailRegex.test(value));
  };
  
  const validateMobile = (value) => {
    const mobileRegex = /^\+\d{7,15}$/;
    setMobileError(!mobileRegex.test(value));
  };
  
  
  // Confirm Password validation (must match Password)
  const validateConfirmPassword = (value) => {
    setConfirmPasswordError(value !== password);
  };
  
  
    const handleSubmitSignup = async () => {
    // Run all validations first
    validateUsername(username);
    validateEmail(email);
    validateMobile(mobile);
    validatePassword(password);
    validateConfirmPassword(confirmPassword);
  
    // Check for any errors or empty required fields
    if (
      usernameError ||
      emailError ||
      mobileError ||
      passwordError ||
      confirmPasswordError ||
      !firstName ||
      !lastName ||
      !username ||
      !email ||
      !mobile ||
      !password ||
      !confirmPassword
    ) {
      toast.error("Please fix form validation errors before submitting.", {
        autoClose: 1500,
        position: "top-right",
      });
      return;
    }
  
    setLoading(true);
  
    const formData = new FormData();
    formData.append("email", email);
    formData.append("username", username);
    formData.append("first_name", firstName);
    formData.append("last_name", lastName);
    formData.append("phone", mobile);
    formData.append("address", address);
    formData.append("password", password);
    if (image) {
      formData.append("image", image);
    }
  
    try {
      const response = await axios.post(
        `${config.base_url}/api/HappyMarineShipping/signup`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      if (response.data.status === 200) {
    toast.success("Registered Successfully", {
      autoClose: 1500,
      position: "top-right",
      onClose: () => navigate("/login"),
    });
  } else if (
    response.data.status === 400 &&
    response.data.message === "Email already exists"
  ) {
    toast.error("Email already exists", {
      autoClose: 1500,
      position: "top-right",
    });
  } else if (
    response.data.status === 400 &&
    response.data.message === "Username already exists"
  ) {
    toast.error("Username already exists", {
      autoClose: 1500,
      position: "top-right",
    });
  } else {
    toast.error("Something went wrong. Try again.", {
      autoClose: 1500,
      position: "top-right",
    });
  }
  
    } catch (err) {
      console.error(err);
      toast.error("Network error. Please try again.", {
        autoClose: 1500,
        position: "top-right",
      });
    } finally {
      setLoading(false);
    }
  };
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const navigate = useNavigate('')


    const [resetEmail, setResetEmail] = useState("");
const [resetLoading, setResetLoading] = useState(false);

const handleForgotPassword = async () => {
  if (!resetEmail) {
    toast.error("Please enter your email");
    return;
  }
  setResetLoading(true);
  try {
    const res = await axios.post(`${config.base_url}/api/HappyMarineShipping/forgot-password/`, {
      email: resetEmail,
    });
    if (res.data.status === 200) {
      toast.success("Reset link sent to your email");
      setSignin("Signin");
    } else {
      toast.error(res.data.message);
    }
  } catch (err) {
    toast.error("Something went wrong");
  } finally {
    setResetLoading(false);
  }
};

const location = useLocation()

const navLinks = [
  { label: "Home", path: "/adminHome" },
  { label: "Ship Sale/Purchase", path: "/adminShipForSale" },
  { label: "Open Ships", path: "/map/ship-chartering" },
  { label: "Open Cargo", path: "/map/open-cargo" },
  { label: "Contact Us", path: "/admincontact" },
];



 const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("admin");
    window.location.href = "/login"; // redirect to login
  };

  
    const [isOpen, setIsOpen] = useState(false);
      const dropdownRef = useRef(null);
    
      // Toggle dropdown
      const toggleDropdownprofile = (e) => {
        e.stopPropagation(); // Prevent click event from bubbling
        setIsOpen((prev) => !prev);
      };
    
      // Close dropdown when clicking outside
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
          }
        };
    
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
      }, []);
  return (
    <div>
    <header className="mx-auto px-[110px] xm:px-3 py-6 bg-[#9ccee2] border-b border-[#123557] flex items-center justify-between">
      <div className="flex  items-center gap-2">
        <div className="flex  h-16 w-[250px] m-auto items-center justify-center rounded-full text-sm font-extrabold text-white ">
          <Link to={'/adminHome'}><img src={Logo} className="mt-10"  alt="" /></Link>
        </div>
        {/* <span className="text-lg font-semibold tracking-tight text-slate-900">
          Mariniz
        </span> */}
      </div>
  <div className="">
        <i
          onClick={toggleSidebar}
          className={`bx ${isSidebarOpen ? "bx-x" : "bx-menu"} hidden L:block  mt-5 text-white text-[40px] cursor-pointer`}
        ></i>
      </div>
      <nav className="flex items-center xm:hidden gap-8 text-[15px] text-slate-600">
  {navLinks.map((item) => {
    const isActive = location.pathname === item.path;
    return (
      <Link
        key={item.label}
        to={item.path}
        className={`transition-colors hover:text-slate-900 ${
          isActive ? "font-semibold text-slate-900" : ""
        }`}
      >
        {item.label}
      </Link>
    );
  })}

  <div className="relative ml-auto  flex items-center gap-20">
         
          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[50px] h-[50px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to="/login/Dashboard">Dashboard</Link>
                  </li>
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                  <button onClick={handleLogout} className="text-red-500"><i class='bx bx-log-out'></i> Logout</button>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
</nav>
<div
      className={`fixed top-0 right-0 h-full bg-gray-100 shadow-lg transform ${
        isSidebarOpen ? "translate-x-0" : "translate-x-full"
      } transition-transform duration-300 z-50 w-[250px]`}
    >
      <div className="p-4">
        <div className="flex justify-between">
          <h2 className="text-lg font-bold mb-4">Menu</h2>
          <p onClick={toggleSidebar}>
            <i className="fa-solid fa-circle-chevron-right text-xl"></i>
          </p>
        </div>
        <ul className="space-y-4">
          <li><Link to="/adminHome"  onClick={toggleSidebar}>Home</Link></li>
          <li><Link to="/adminShipForSale" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Ship Sale/Purchase</Link></li>
          <li><Link to="/map/ship-chartering" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Open ships</Link></li>
          <li><Link to="/map/open-cargo" className="text-gray-800 hover:text-blue-300 block" onClick={toggleSidebar}>Open Cargo</Link></li>
          <li><Link to="/contact" className="text-gray-800 hover:text-blue-500 block" onClick={toggleSidebar}>Contact Us</Link></li>
          <li><Link to="/login/Dashboard" className="bg-blue-600 text-white  rounded py-2 px-2 block text-center" onClick={toggleSidebar}>Dashboard</Link></li>
          <li><Link onClick={() => navigate('/regShip')} className="bg-[#d1a460] text-black hover:bg-[#af9164] rounded py-2 px-2 block text-center" >+ Register your Ship</Link></li>
        </ul>
      </div>
    </div>
    </header>
    </div>
  );
}
